import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react';

type OsWindowHeaderAddonSetter = (addon: ReactNode) => void;

export const OsWindowHeaderAddonContext =
  createContext<OsWindowHeaderAddonSetter | null>(null);

/** The shell's slot: whatever the page in the window last registered. */
export const useOsWindowHeaderAddonRegistry = () => {
  const [headerAddon, setHeaderAddon] = useState<ReactNode>(null);

  return { headerAddon, setHeaderAddon };
};

/**
 * Puts `addon` in the default OS window header, beside the window controls —
 * a page-owned control that belongs in the chrome (the Dashboard's default-view
 * pin). Cleared on unmount or when `addon` becomes null.
 * Memoise the node in the page so the slot is not rewritten on every render.
 */
export const useOsWindowHeaderAddon = (addon: ReactNode): void => {
  const setHeaderAddon = useContext(OsWindowHeaderAddonContext);

  useEffect(() => {
    if (!setHeaderAddon) return;

    setHeaderAddon(addon);

    return () => setHeaderAddon(null);
  }, [addon, setHeaderAddon]);
};
